// components/Certifications.js
import React, { useState, useEffect } from 'react';
import './Certifications.css';

// 方式2：使用 import 导入（更可靠）
import cert1 from '../asste/images/p/p1.png';
import cert2 from '../asste/images/p/p2.jpg';
import cert3 from '../asste/images/p/p3.png';
import cert4 from '../asste/images/p/p4.png';
import cert5 from '../asste/images/p/p5.png';

const certificationImages = [cert1, cert2, cert3,cert4, cert5];

const Certifications = () => {
  const [currentImage, setCurrentImage] = useState(0);
  
  // 资质证书图片数组（您可以替换为实际的图片路径）
  const certificationImages = [cert1, cert2, cert3,cert4,cert5];

  // 自动轮播功能
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % certificationImages.length);
    }, 4000); // 每4秒切换一张图片
    
    return () => clearInterval(timer);
  }, [certificationImages.length]);

  // 手动切换图片
  const goToImage = (index) => {
    setCurrentImage(index);
  };

  return (
    <section className="certifications" id="certifications">
      <div className="container">
        <h2>我们的资质证书</h2>
        <p className="certifications-intro">
          我们拥有专业的资质认证，确保为客户提供高质量的环保技术服务。
        </p>
        
        <div className="carousel-container">
          <div className="carousel-track" style={{ transform: `translateX(-${currentImage * 100}%)` }}>
            {certificationImages.map((image, index) => (
              <div className="carousel-slide" key={index}>
                <img 
                  src={image} 
                  alt={`资质证书 ${index + 1}`} 
                  onError={(e) => {
                    // 如果图片加载失败，显示占位符
                    e.target.src = '资质证书+' + (index + 1);
                  }}
                />
              </div>
            ))}
          </div>
          
          {/* 轮播指示器 */}
          <div className="carousel-indicators">
            {certificationImages.map((_, index) => (
              <button
                key={index}
                className={`indicator ${currentImage === index ? 'active' : ''}`}
                onClick={() => goToImage(index)}
                aria-label={`跳转到第 ${index + 1} 张图片`}
              ></button>
            ))}
          </div>
          
          {/* 左右导航按钮 */}
          <button 
            className="carousel-btn prev" 
            onClick={() => setCurrentImage((currentImage - 1 + certificationImages.length) % certificationImages.length)}
            aria-label="上一张"
          >
            ❰
          </button>
          <button 
            className="carousel-btn next" 
            onClick={() => setCurrentImage((currentImage + 1) % certificationImages.length)}
            aria-label="下一张"
          >
            ❱
          </button>
        </div>
      </div>
    </section>
  );
};

export default Certifications;